import {
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { combineLatest } from 'rxjs';

import { AuthService } from '@Services/auth';
import {
  EvaluationService, Page, PageHelper, PageNode, PageService, Site,
  SiteService,
} from '../common/services';
import { Individu, IndividuService } from '../../common/core/services/campagne_emplois';
import {rolesBdc} from '../common/enum/roles-bdc';
import { tap } from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';
import {PubSubService} from '../common/services/pub-sub.service';


@Component({
  selector: 'p8-bdc-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  can_edit: boolean;
  errorMsg: any;
  page: Page;
  currentTree: PageNode;
  individu: Individu;
  site: Site = null;
  opened = true;
  sidenavMode = 'side';

  slug = '';
  private dom: Document;
  hasCopy = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private evaluationService: EvaluationService,
    private individuService: IndividuService,
    private pageHelper: PageHelper,
    private pageService: PageService,
    private router: Router,
    private siteService: SiteService,
    private pubsubService: PubSubService,
    @Inject(DOCUMENT) dom: Document
  ) {
    this.dom = dom;
  }

  private _setPage(data) {
    this.page = data;
    this.slug = this.pageHelper.getSlug(this.page);
    this.testCopy();
  }


  ngOnInit() {
    this.can_edit = false;
    this.toggleSidenav({ target: window });

    this.individuService.individu$.subscribe(ind => {
      this.individu = ind;
    });

    const site$ = this.siteService.list().pipe(
      tap(data => {
      if (data && data.length  > 0) {
        this.site = data[0];
      }
    }));

    this.activatedRoute.params.subscribe(params => {
      const id = Number(params['id']);

      this.canEdit(id);

      const page$ = id
        ? this.pageService.get(id).pipe(tap(data => this._setPage(data)))
        : this.pageService.getBySlug(params['id']).pipe(tap(data => this._setPage(data)));

      combineLatest([site$, page$]).subscribe(([site, page]) => {
        this.currentTree = this.pageHelper.calculateCurrentPageTree(true, this.site.pages.children, this.page.id);
      });
    });
  }
  getPages(children) {
    if (children) {
      return [...children];
    }
    return [];
  }
  /**
   * Changement de page au click de l'arbo
   * @param node
   */
  onClick(node) {
    if (node.level !== 0) {
      this.router.navigate(['page', node.item.id]);
    }
  }
  /**
   * voir ce module full Angular https://github.com/maxisam/ngx-clipboard
   *
   * solution JS :
   * https://stackoverflow.com/a/45982786/55465
   * en faire une directive avec https://stackoverflow.com/a/49289166/55465 ?
   * @param event
   */
  copyLink(event) {
    try {
      const element = this.dom.getElementById('slugLink');
      ((<any>element)).select();
      this.dom.execCommand('copy');
      element.blur();
    } catch (e) {
      console.log('e ', e.stack);
    }
    finally {
      // this.dom.getSelection().removeAllRanges();
    }
  }

  openPage(page: Page) {
    this.router.navigate([`/settings/pages/${page.id}`, 'edit']);
  }

  isAdmin() {
    if (this.individu) {
      return this.individuService.hasRole(this.individu, rolesBdc.admin);
    }
    return false;
  }

  canEdit(pageid: number) {
    this.can_edit = false;

    if (this.individu) {
      if (this.individuService.hasRole(this.individu, rolesBdc.admin) ||
          this.individuService.hasRole(this.individu, rolesBdc.supergestionnaire)) {
        this.can_edit = true;
      }

      if (this.individuService.hasRole(this.individu, rolesBdc.gestionnaire)) {
        this.pageService.canEdit(pageid).subscribe(
          data => {
            this.can_edit = data;
          },
          err => {
            this.errorMsg = <any>err;
          });
      }
    }
  }

  toggleSidenav($event: any) {
    this.sidenavMode = ($event.target.innerWidth < 920) ? 'push' : 'side';
    this.opened = ($event.target.innerWidth < 920) ? false : this.opened;
  }

  selectFromMyCategories(e: any) {
    e.node.toggleExpanded();
    if (e.node.data.id && !e.node.data.children) {
      this.router.navigate(['page', e.node.data.id]);
    }
  }

  loggedIn(): boolean {
    return this.authService.loggedIn();
  }

  testCopy() {
    try {
      const element = this.dom.getElementById('slugLink');
      ((<any>element)).select();
      this.dom.execCommand('copy');
      element.blur();

      setTimeout(() => this.hasCopy = true);
    } catch (e) {
      setTimeout(() => this.hasCopy = false);
    }
  }

}
